exports.default = {
  'account_settings': '账号设置',
  'nickname': '昵称',
  'nickname_placeholder': '请输入昵称',
  'add_avatar': '添加头像',
  'email_address': '邮箱地址',
  'change_email': '更改邮箱',
  'device_management': '设备管理',
  'device_tip': '退出其他设备即可，此设备除外',
  'logout_all_devices': '从所有设备退出',
  'device_name': '设备名称',
  'current_device': '此设备',
  'last_active_time': '上次活跃时间',
  'now': '现在',
  'location': '位置',
  'logout': '退出',
  'delete_my_account': '删除我的账号',
  'delete_account_tip': '永久删除账号并删除所有工作空间的访问权限',
  'crop_image': '剪切图片',
  'need_crop_image': '是否需要剪切图片？',
  'crop': '剪切',
  'upload_without_crop': '不剪切直接上传',
  'upload_image': '上传图片',
  'cancel': '取 消',
  'confirm': '确 定',
  'change_email_title': '更改邮箱',
  'no_email_tip': '您还未绑定邮箱，请设置您的邮箱地址。',
  'current_email_is': '您当前的邮件地址是：',
  'will_send_code': '，我们将向此电子邮件地址发送临时验证码。',
  'verification_completed': '已完成验证',
  'code_sent': '我们已向此电子邮件地址发送临时验证码。',
  'enter_verification_code': '请输入验证码',
  'retry_later': '{newEmailTimer}s后重试',
  'resend': '重新发送',
  'enter_new_email': '请输入新的电子邮件地址，我们将向你发送验证码',
  'enter_new_email_placeholder': '请输入新的邮箱地址',
  'verification_tip': '我们刚刚向你的邮箱 {email} 发送了一个临时验证码',
  'enter_new_email_code': '请输入新邮箱验证码',
  'send_code': '发送验证码',
  'verify': '验证',
  'bind_email': '绑定邮件地址',
  'change_email_action': '更改邮件地址',
  'delete_account': '删除账号',
  'delete_warning': '警告：该操作无法撤销，删除后，您的账号数据都会被删除，并退出其他团队。',
  'confirm_by_email': '请输入您的邮箱确认删除：',
  'confirm_by_phone': '请输入您的手机号确认删除：',
  'enter_email_confirm': '请输入邮箱确认',
  'enter_phone_confirm': '请输入手机号确认',
  'confirm_delete_account': '删除账号',
  'nickname_empty': '昵称不能为空',
  'save_success': '保存成功！',
  'image_type_error': '图片类型必须是：gif,jpeg,jpg,png,bmp中的一种',
  'email_required': '请输入新邮箱地址',
  'email_invalid': '请输入有效的邮箱地址',
  'email_duplicate': '新邮箱不能与当前邮箱相同',
  'code_required': '请输入验证码',
  'token_invalid': '验证令牌已失效，请重新开始',
  'email_bind_success': '邮箱绑定成功！请重新登录',
  'email_update_success': '邮箱更新成功！请重新登录',
  'logout_success': '已退出所有其他设备',
  'operation_failed': '操作失败',
  'logout_current_device': '正在退出当前设备...',
  'logout_device_success': '已成功退出设备',
  'logout_failed': '退出失败',
  'email_incorrect': '邮箱输入不正确，无法删除账号',
  'phone_incorrect': '手机号输入不正确，无法删除账号',
  'identity_verification': '无法验证您的身份，请先绑定邮箱或手机号',
  'account_deleted': '账号已删除',
  'delete_account_failed': '删除账号失败',
  'get_device_list_failed': '获取设备列表失败',
  'account_center': '账号中心',
  'preferences': '偏好设置',
  'subscription_management': '订阅管理',
  'bill': '账单',
  'consumption_records': '消费记录',
  'no_consumption_records': '暂无积分消费记录',
  'points_details': '积分明细',
  'points_event': '积分事件',
  'occurred_at': '发生时间',
  'points_change': '积分变化',
  'points_balance': '剩余积分',
  'loading_more': '正在加载更多...',
  'no_more_records': '没有更多记录',
  'points_earned': '获取积分',
  'points_expired': '积分过期',
  'points_adjusted': '积分调整',
  'points_consumption': '积分消费',
  'agent_task': 'Agent任务',
  'expand_details': '展开明细',
  'collapse_details': '收起明细',
  'refresh_records': '刷新记录',
  'video_generation': '视频生成',
  'video_generation_model': '视频生成 · {model}',
  'video_points_reserved': '已预占 {points} 积分，未扣费',
  'video_points_committed': '预占已转扣',
  'video_points_released': '预占已释放',
  'video_points_group_held': '当前预占 {points} 积分',
  'video_points_provisional': '按预估暂扣',
  'video_points_refund': '退还差额',
  'video_points_supplemental': '补扣差额',
  'video_points_adjustment': '积分调整',
  'video_points_settled': '已结算',
  'date': '日期',
  'plan_name': '方案名称',
  'unpaid': '（未完成支付）',
  'amount': '金额',
  'invoice': '发票',
  'download_pdf': '下载PDF',
  'view_receipt': '查看收据',
  'downloading': '正在下载中......',
  'loading_bill_failed': '加载账单失败',
  'important_info': '重要信息',
  'membership_expiry': '关闭自动续订后，您的会员资格将会在{endTime}到期。到期后，您将失去以下功能:',
  'special_offer': '特别优惠',
  'discount_info': '继续订阅，能享受下一年度{discount_percent}%的折扣优惠! 折扣价{price} (原价{original_price})',
  'continue_subscription': '继续订阅并享受折扣',
  'reason_prompt': '请告诉我们您选择关闭自动续订的原因：',
  'reason_price': '价格太高使用频率不高',
  'reason_features': '功能不符合需求',
  'reason_alternative': '转用其他产品',
  'reason_other': '其他原因',
  'enter_specific_reason': '请输入具体原因',
  'keep_auto_renewal': '保持自动续订',
  'confirm_cancel_renewal': '确认关闭自动续订',
  'close_subscription_failed': '关闭订阅失败',
  'return': '返回',
  'modify_payment': '修改支付方式',
  'add_new_payment': '添加新的支付方式',
  'payment_update_tip': '更新您的卡信息，确保订阅可以顺利续期。更新不会立即产生任何费用。',
  'credit_debit_card': '信用卡/借记卡',
  'card_number': '卡号',
  'cardholder_name': '持卡人姓名',
  'enter_cardholder_name': '请输入持卡人姓名',
  'expiration_date': '有效期',
  'security_code': '安全码',
  'payment_security_warning': '您的支付信息安全加密处理，更新卡信息不会立即产生费用，仅在下次计费日使用。',
  'save_payment_method': '保存支付方式',
  'stripe_init_failed': 'Stripe初始化失败',
  'payment_component_init_failed': '初始化支付组件失败: ',
  'unknown_error': '未知错误',
  'get_payment_config_failed': '获取支付配置失败',
  'get_payment_key_failed': '获取支付密钥失败',
  'enter_cardholder_name_prompt': '请输入持卡人姓名',
  'enter_valid_card_number': '请输入有效的卡号',
  'enter_valid_expiry': '请输入有效的卡片有效期',
  'enter_valid_cvc': '请输入有效的安全码',
  'create_payment_config_failed': '创建支付配置失败',
  'payment_method_update_success': '支付方式更新成功',
  'payment_method_update_failed': '支付方式更新失败，请稍后再试',
  'payment_success': '支付成功',
  'thank_you': '感谢您的购买！',
  'upgrade_success': '您已成功升级至{verName}',
  'privilege_activated': '{verName}特权已激活',
  'try_now': '立即体验',
  'choose_plan': '选择套餐方案',
  'plan_description': '选择适合您的套餐，随时可以升级或降级',
  'yearly': '年付',
  'monthly': '月付',
  'save_percent_planbuy': '省{currentDiscount}%',
  'most_popular': '最受欢迎',
  'recommended': '推荐',
  'price_period_year': '/年',
  'price_period_month': '/月',
  'selected': '已选择',
  'select_plan': '选择{plan}',
  'purchase_title': '选择你的会员方案',
  'purchase_subtitle': '把更多时间留给创作，权益即时生效。',
  'purchase_account_fallback': '会员账号',
  'membership_expires_on': '会员有效期至 {expiryDate}',
  'purchase_free_member': '免费版',
  'purchase_paid_member': '付费会员',
  'purchase_domestic': '中国大陆版',
  'purchase_international': '国际版',
  'purchase_domestic_note': '仅支持单次购买，微信或支付宝扫码支付',
  'purchase_international_note': '支持连续包月与连续包年，随时可取消',
  'purchase_billing_label': '选择购买周期',
  'purchase_version_label': '选择会员版本',
  'purchase_period_hint': '按周期选择最适合你的价格',
  'purchase_benefits_kicker': '会员权益',
  'purchase_period_month': '月付',
  'purchase_period_quarter': '季付',
  'purchase_period_half_year': '半年付',
  'purchase_period_year': '年付',
  'purchase_period_two_year': '两年付',
  'purchase_choose_plan': '选择适合你的方案',
  'purchase_previous_plan': '上一组方案',
  'purchase_next_plan': '下一组方案',
  'purchase_single_year': '包年',
  'purchase_single_month': '包月',
  'purchase_yearly': '连续包年',
  'purchase_monthly': '连续包月',
  'purchase_save_badge': '省更多',
  'purchase_monthly_equivalent': '折合每月',
  'purchase_one_time': '单次购买，到期后不会自动续费',
  'purchase_auto_renew': '自动续订，可随时取消',
  'purchase_domestic_footnote': '支付成功后权益即时到账，订单可在账单中查看。',
  'purchase_international_footnote': '安全支付由 Stripe 提供，续订设置可在账户中心管理。',
  'purchase_selected_plan': '当前选择',
  'purchase_owner_only': '仅团队所有者可管理订阅，您仍可查看团队套餐和积分。',
  'purchase_quote_loading': '正在计算订阅金额…',
  'purchase_quote_failed': '应付金额计算失败，请重试后再订阅。',
  'purchase_quote_retry': '重新计算',
  'purchase_plan_price': '套餐价格',
  'purchase_credit': '原付费套餐抵扣',
  'purchase_quote_note': '抵扣仅用于首个计费周期，下单时重新计算实际金额；后续续订按套餐正常价格扣款。',
  'purchase_select_plan_hint': '请选择一个方案',
  'purchase_pay_now': '立即购买',
  'purchase_select': '选择方案',
  'purchase_payment_step': '02 · 支付',
  'purchase_scan_title': '扫码完成支付',
  'purchase_payable': '应付金额',
  'purchase_scan_description': '请选择微信或支付宝完成支付，支付完成后页面会自动更新。',
  'purchase_payment_method': '支付方式',
  'wechat': '微信支付',
  'purchase_agreement': '支付即表示你同意《会员服务协议》和《隐私政策》',
  'purchase_refresh': '刷新二维码',
  'purchase_payment_done': '我已完成支付',
  'purchase_qr_refreshed': '二维码已刷新',
  'purchase_self_invoice': '自助开票',
  'purchase_invoice_help': '购买后可前往账号中心-账单记录内自助开具发票。',
  'purchase_payment_channels_failed': '可用支付方式加载失败',
  'purchase_no_payment_channel': '当前暂无可用的支付方式，请稍后重试',
  'purchase_no_plan': '暂无可购买的会员方案',
  'purchase_no_matching_plan': '暂时没有符合您的套餐',
  'purchase_qr_loading': '正在生成支付二维码',
  'purchase_payment_pending': '暂未查询到支付结果，请完成支付后重试',
  'purchase_fuel_packages': '购买加油包',
  'purchase_fuel_packages_note': '加油包积分单独生效',
  'purchase_buy_now': '立即购买',
  'purchase_renew_now': '立即续费',
  'purchase_upgrade_now': '立即升级',
  'purchase_subscribe_now': '立即订阅',
  'purchase_no_fuel_packages': '暂无可购买的加油包',
  'proceed_to_payment': '前往支付',
  'repay': '重新支付',
  'unfinished_payment_tips': '支付尚未完成，请点击‘重新支付’继续操作。如需帮助，请联系客服。',
  'select_plan_prompt': '请选择一个套餐方案',
  'processing_payment': '正在处理支付...',
  'get_plan_id_failed': '获取方案ID失败',
  'create_payment_session_failed': '创建支付会话失败',
  'payment_error': '支付过程中发生错误',
  'payment_status_timeout': '支付状态查询超时',
  'order_cancelled': '订单已取消',
  'query_order_failed': '查询订单信息失败',
  'appearance': '外观',
  'theme_customization': '自定义系统主题色',
  'language': '语言',
  'change_language': '更改用户界面语言',
  'config_load_failed': '配置加载失败',
  'user_settings_load_failed': '用户设置加载失败',
  'save_failed': '保存失败',
  'free_desc': '免费版提供基础功能体验，升级到付费版可解锁更多高级功能和更高的使用限额。',
  'upgrade': '升级',
  'buy_points': '增购积分',
  'points_usage': '积分使用量',
  'storage_usage': '存储使用量',
  'points_quota_tip': '{points_quota_used_numerical}/{points_quota_total_numerical}积分',
  'storage_quota_tip': '共计{storage_quota_total_numerical}GB，剩余{storage_quota_surplus_numerical}GB',
  'all_plans': '所有方案',
  'current_tag': '当前方案',
  'current_plan': '当前方案',
  'save_percent': '省{currentPriceInfo}%',
  'valid_status': '有效',
  'expiring_status': '即将过期',
  'subscription_active': '您的年度订阅已激活，自动续订已开启。',
  'auto_renewal_off': '您已关闭自动续订。您仍可继续使用所有功能直至订阅到期。',
  'subscription_expiry_warning': '您的订阅将于{endTime}到期。到期后，您将失去所有会员特权。',
  'restore_subscription': '恢复续订',
  'subscription_period': '订阅周期',
  'next_payment_date': '下次扣款日期',
  'next_payment_amount': '下次扣款金额',
  'subscription_status': '订阅状态',
  'auto_renewal_on': '自动续订已开启',
  'auto_renewal_off_status': '自动续订已关闭',
  'expires_on': '有效期至 {expiryDate}',
  'card_expired': '已过期',
  'change': '更改',
  'card_expiry_warning': '您的支付卡已过期，为确保服务不中断，请更新为有效的支付方式。这不会立即扣款，',
  'next_payment_notice': '仅在下次续费周期{nextPaymentDate}时使用。',
  'auto_renewal_status_on': '自动续订已开启',
  'auto_renewal_status_off': '自动续订已关闭',
  'renewal_on_details': '自动续订已开启。您的会员资格将在{nextPaymentDate}自动续期，届时将向您收取 {nextPaymentAmount}的年费',
  'renewal_off_details': '自动续订已关闭。您的会员资格将在{endTime}到期，开启自动续订可继续享受所有会员特权。',
  'upgrade_plan': '升级套餐',
  'current_benefits': '当前权益',
  'highest_version': '您当前已升至最高版本',
  'light': '浅色',
  'dark': '深色',
  'system': '跟随系统',
  'alipay': '支付宝',
  // 积分管理
  'points_management': '积分管理',
  'total_points': '总积分',
  'subscription_points': '订阅积分',
  'purchased_points': '增购积分',
  'activity_points': '活动积分',
  'buy_points_packages': '购买积分拓展包',
  'buy_now': '立即购买',
  'points_package': '积分包',
  'get_points_info_failed': '获取积分信息失败',
  'get_package_list_failed': '获取拓展包列表失败'
}
